enum BreadcrumbsTitles {
  COMPANY_DATABASE = "Our people",
  MY_FAVORITES = "My Favorites",
  REQUESTS = "External Sourcing",
  REQUEST_DETAILS = "External Sourcing Details",
  MARKETPLACE = "Marketplace",
  MANAGERS = "Managers",
  MANAGER_DETAILS = "Manager details",
  PROJECTS = "Clients",
  ALL_CLIENTS = "All Clients",
  ALL_VISITS = "All Visits",
  ALL_EMPTY_VISITS_TAB = "All Open Visits",
  PENDING_VISITS = "Offered Visits",
  ALL_DRAFT_VISITS = "Draft Visits",
  MANAGE_MAIN_CLIENTS = " Clients & Visits ",
  ACCEPTED_VISITS = "Assigned Visits",
  COMPLETED_VISITS = "Completed Visits",
  REJECTED_VISITS = "Rejected Visits",
  ALL_COMPLETED_CLIENTS = "Closed profiles",
  ALL_ACTIVE_CLIENTS = "Active profiles",
  ALL_DRAFT_CLIENTS = "Draft profiles",
  PROJECT_DETAILS = "Client Details",
  ALL_EMPTY_VISITS = "Open Visits",
  PROJECT_ACTIVITIES = "Project Tasks",
  PROJECT_DOCUMENTS = "Project Documents",
  PROJECT_CONTRACTORS = "Project Contractors",
  GROUPS = "Groups",
  GROUP_DETAILS = "Group details",
  FAVORITE="Favorites",
  POSTINGS = "Job Postings",
  POSTING = "Postings",
  JOB_BOARD = "Job Board",
  POSTING_DETAILS = "Job Postings",
  POSTING_APPLICANTS = "Posting applicants",
  MY_CONTRACTORS = "My Resources",
  ALL_DOCUMENTS = "Documents",
  PROJECTS_DOCUMENTS = "Documents attached to clients",
  CONTRACTORS_DOCUMENTS = "Documents attached to contractors",
  MANAGERS_DOCUMENTS = "Documents attached to managers",
  CONTRACTOR_DETAILS = "Resource details",
  COMPANY_DETAILS = "Company details",
  INBOX = "Inbox",
  DASHBOARD = "Dashboard",
  INTERNAL = "Internal",
  APPLICATIONS = "Applications",
  CONNECTIONS = "Connections",
  COMPANIES = "Companies",
  NOTIFICATIONS = "Notifications",
  USER_PROFILE = "User profile",
  USER_SETTINGS = "User Settings",
  SCHEDULER = "Scheduler",
  MANGERS_SCHEDULER = "My Scheduler",
  NEWSCHEDULER = "Scheduler",
  COMPANY_PROFILE = "Permissions",
  COMPANY_SETTINGS = "Permissions",
  TALENT_MAPPING = "Talent Mapping",
  TIMESHEETS = "Timesheets",
  MANAGE_COMPANIES = "Manage Company",
  COMPANY_RESOURCES = "Company Resources",
}

export default BreadcrumbsTitles;
